import { createSlice } from "@reduxjs/toolkit";
import { setMessage } from "./messageReducer";
import {
  DefaultModalData,
  TopicSlider,
  AdvancedSetting,
} from "services/api/index";

export const defaultModalsDataSlice = createSlice({
  name: "defaultModalsData",
  initialState: {
    defaultModalsData: {},
    defaultModalsDataLoading: false,
    otherLoading: false,
    runId: "",
    basicVariables: {
      user_city: "",
      user_state: "",
      user_income: 75000,
      user_adults: 1,
      user_infants: 0,
      user_kids: 0,
      user_own: 1,
    },
    sliderVariables: null,
  },
  reducers: {
    setDefaultModalsDataLoading: (state, action) => {
      state.defaultModalsDataLoading = action.payload;
    },

    setOtherLoading: (state, action) => {
      state.otherLoading = action.payload;
    },

    setRunId: (state, action) => {
      state.runId = action.payload;
    },

    setBasicVariables: (state, action) => {
      state.basicVariables = action.payload;
    },

    setSliderVariables: (state, action) => {
      state.sliderVariables = action.payload;
    },

    setDefaultModalsData: (state, action) => {
      state.defaultModalsData = action.payload;
    },

    setRanksData: (state, action) => {
      state.defaultModalsData.ranks = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setDefaultModalsDataLoading,
  setOtherLoading,
  setRunId,
  setBasicVariables,
  setSliderVariables,
  setDefaultModalsData,
  setRanksData,
} = defaultModalsDataSlice.actions;

export const getDefaultModalsData = (history, payload) => async (dispatch) => {
  dispatch(setBasicVariables(payload.basic_variables));
  dispatch(setSliderVariables(payload.slider_variables));
  dispatch(setDefaultModalsDataLoading(true));
  try {
    const response = await DefaultModalData.index(payload);
    dispatch(setDefaultModalsData(response.data.body));
    dispatch(setRunId(payload.basic_variables.run_id));
    dispatch(
      setSliderVariables({
        ind_climate: response.data.body.climate.climate_slider,
        ind_mm: response.data.body.mm.moneymatters_slider,
        ind_pom: response.data.body.pom.peaceofmind_slider,
        ind_inf: response.data.body.infrastructure.infrastructure_slider,
        ind_dem: response.data.body.community.community_slider,
        ind_sch: response.data.body.education.education_slider,
      })
    );
    history.push("/search-result");
  } catch (err) {
    dispatch(setMessage({ message: err.message }));
  }
  dispatch(setDefaultModalsDataLoading(false));
};

export const updateTopicSlider = (payload) => async (dispatch, getState) => {
  dispatch(setOtherLoading(true));
  dispatch(setSliderVariables(payload.slider_variables));
  console.log("here");
  try {
    const runId = getState().defaultModalsDataReducer.runId;
    let { slider_variables } = payload;
    const params = { ...slider_variables, run_id: runId };
    const response = await TopicSlider.update({ slider_variables: params });
    dispatch(setRanksData(response.data.body));
  } catch (err) {
    console.log(err);
    dispatch(setMessage({ message: err.message }));
  }
  dispatch(setOtherLoading(false));
};

export const updateAdvancedSetting =
  (topic, payload) => async (dispatch, getState) => {
    dispatch(setOtherLoading(true));
    try {
      const runId = getState().defaultModalsDataReducer.runId;
      let newPayload = { ...payload };
      newPayload[topic].run_id = runId;
      // To-Do update lambda API, remove this snippets
      const payloadUpdates = {
        climate: {
          precipitation: "precipitation",
        },
        pom: {
          flag_fema_nri_score: "flag_nri",
          flag_airpopulation: "flag_airquality",
        },
        education: {
          flag_Elementary: "flag_number_el",
          flag_Private_to_public_ratio_el: "flag_private_ratio_el",
          flag_avg_math_el: "flag_math_proficiency_el",
          flag_avg_rla_el: "flag_rla_proficiency_el",
          flag_avg_teacher_salary_el: "flag_teacher_salary_el",
          flag_Middle: "flag_number_mid",
          flag_Private_to_public_ratio_mid: "flag_private_ratio_mid",
          flag_avg_math_mid: "flag_math_proficiency_mid",
          flag_avg_rla_mid: "flag_rla_proficiency_mid",
          flag_avg_teacher_salary_mid: "flag_teacher_salary_mid",
          flag_High: "flag_number_high",
          flag_Private_to_public_ratio_high: "flag_private_ratio_high",
          flag_avg_math_high: "flag_math_proficiency_high",
          flag_avg_rla_high: "flag_rla_proficiency_high",
          flag_avg_teacher_salary_high: "flag_teacher_salary_high",
          flag_student_teacher_ratio_el: "flag_student_teacher_ratio_el",
          flag_student_teacher_ratio_mid: "flag_student_teacher_ratio_mid",
          flag_student_teacher_ratio_high: "flag_student_teacher_ratio_high",
        },
      };

      for (const key in payloadUpdates[topic]) {
        const newKey = payloadUpdates[topic][key];
        if (newPayload[topic][key]) {
          newPayload[topic][newKey] = newPayload[topic][key];
        } else {
          newPayload[topic][newKey] = 0;
        }
      }
      const response = await AdvancedSetting.update(topic, newPayload);
      dispatch(setRanksData(response.data.body));
    } catch (err) {
      dispatch(setMessage({ message: err.message }));
    }
    dispatch(setOtherLoading(false));
  };

export default defaultModalsDataSlice.reducer;
